import { render, staticRenderFns } from "./conversation-list-avatar.vue?vue&type=template&id=0316e629"
import script from "./conversation-list-avatar.vue?vue&type=script&lang=js"
export * from "./conversation-list-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports